import React, { useContext, useEffect, useState } from 'react';
import './NavTest.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faFile, faFolderOpen } from '@fortawesome/free-solid-svg-icons';
import { ColorsContext } from '../composants/colorContext';
import { useLocation } from 'react-router-dom';
import axiosInstance from '../configurations/axiosInstance/AxiosInstance';
import { formatAuthor } from '../composants/utils/utils';
import { toast } from 'react-toastify';

export default function NavTestNew() {
  const [ressources, setRessources] = useState(false);
  const [about, setAbout] = useState(false);
  const [ressourcesM, setRessourcesM] = useState(false);
  const [aboutM, setAboutM] = useState(false);
  const {colors} = useContext(ColorsContext);
  const [isOpen, setIsOpen] = useState(false);
  const [articleSubMenu, setArticleSubMenu] = useState([]);
  const [partenaires, setPartenaires] = useState([]);

  const fetchPartenaires = async () => {
    try {
      const response = await axiosInstance().get('public/api/partenaires/active-published');
      setPartenaires(response.data || []);
    } catch (error) {
      //toast.error('Impossible de charger les partenaires');
      setPartenaires([]);
    }
  };

  const fetchMenus = () => {
    axiosInstance().get('/public/api/menu/WEB_SITE')
        .then(response => {
          let menusJson  = response.data.subMenus;
          menusJson.sort((a, b) => a.name.localeCompare(b.name));
          setArticleSubMenu(menusJson);
        })
        .catch(error => { console.error('There was an error!', error); });
  };

  useEffect(() => {
    fetchMenus();
    fetchPartenaires();
  }, []);




  const location = useLocation();
  const [activePath, setActivePath] = useState(location.pathname || '/');

  useEffect(() => {
    setActivePath(location.pathname || '/');
  }, [location]);

  const handleAnchorClick = (e) => {
    const href = e.currentTarget.getAttribute('href') || '';
    try {
      const url = new URL(href, window.location.origin);
      setActivePath(url.pathname);
    } catch (err) {
      setActivePath(href);
    }
  };

  return (
    <header className="navtest">
      <nav className="bg-white shadow-lg w-full h-20">
        <div className="sm:px-6 lg:px-2">
          <div className="relative flex items-center justify-between h-16">
            <div className="flex-1 flex items-center justify-center justify-between sm:items-stretch sm:justify-center w-full ">
              <div className="flex-shrink-0 flex items-center">
                <img src="/images/logo/logo.png" className="block h-8 w-auto" alt="YouthFP" />
                
              </div>
              
              <div className="hidden sm:block sm:ml-6">
                <div className="flex space-x-4">
                  <a href="/" onClick={handleAnchorClick} className={`no-underline text-gray-900 hover:bg-gray-100 px-3 py-2 rounded-md text-sm font-medium ${activePath === '/' ? 'active-link' : ''}`}>Acceuil</a>
                  <div className="relative group" onMouseEnter={() => setRessources(true)} onMouseLeave={() => setRessources(false)}>
                    <button className={`text-gray-900 hover:bg-gray-100 px-3 py-2 rounded-md text-sm font-medium flex items-center ${activePath.startsWith('/articles') || activePath.startsWith('/usraj') || activePath.startsWith('/service') || activePath.startsWith('/gallery') ? 'active-link' : ''}`}>
                      <FontAwesomeIcon icon={faFolderOpen} className="ml-1 h-3 w-3" /> Ressources  <FontAwesomeIcon icon={faChevronDown} className="ml-1 h-3 w-3" />
                    </button>

                    <div
                      className={`absolute left-0 mt-2 w-screen max-w-6xl bg-white border border-gray-200 rounded-lg shadow-lg transition-all duration-300 z-50 transform -translate-x-1/4 ${ressources ? 'opacity-100 visible' : 'opacity-0 invisible'}`}>
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 p-6">
                        {
                          articleSubMenu.length != 0 && <div>
                            <h3 className={`text-lg font-semibold text-gray-900 mb-4 ${activePath.startsWith(`/articles`) ? 'active-link' : ''}`}> <FontAwesomeIcon icon={faFile} className="ml-1 h-4 w-4" />Articles</h3>
                            <ul className="space-y-3">
                              {articleSubMenu.map((menu) => (
                                <li title={menu.description} key={menu.name}><a onClick={handleAnchorClick} className={`no-underline text-gray-600 hover:text-indigo-600 ${activePath === `/articles/${menu.id}` ? 'active-link' : ''}`} style={{textDecoration: 'none'}} href={`/articles/${menu.id}`} >{formatAuthor(menu.description, 117)}</a></li>
                              ))}
                            </ul>
                          </div>
                        }
                        <div>
                          <h3 className={`text-lg font-semibold text-gray-900 mb-4 ${activePath.startsWith('/usraj') || activePath.startsWith('/service') ? 'active-link' : ''}`}>USRAJ</h3>
                          <ul className="space-y-3">
                            <li title="Localisation des Unité de Santé de Reproduction des Ados Jeunes"><a onClick={handleAnchorClick} href="/usraj/location" className={`no-underline text-gray-600 hover:text-indigo-600 ${activePath.startsWith('/usraj') ? 'active-link' : ''}`}>Localisation des USRAJ</a></li>
                            <li title="Services des Unité de Santé de Reproduction des Ados Jeunes"><a onClick={handleAnchorClick} href="/service" className={`no-underline text-gray-600 hover:text-indigo-600 ${activePath.startsWith('/service') ? 'active-link' : ''}`}>Services</a></li>
                          </ul>
                        </div>
                        <div>
                          <h3 className={`text-lg font-semibold text-gray-900 mb-4 ${activePath.startsWith('/gallery') ? 'active-link' : ''}`}>Mediatheque</h3>
                          <div className="bg-gray-100 p-4 rounded-lg">
                            <img src="/images/images.png" alt="Featured Product" className="rounded-lg mb-3" />
                            <a onClick={handleAnchorClick} href="/gallery" className={`no-underline text-indigo-600 hover:text-indigo-800 text-sm font-medium ${activePath.startsWith('/gallery') ? 'active-link' : ''}`}>En Savoir Plus →</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="relative group" onMouseEnter={() => setAbout(true)} onMouseLeave={() => setAbout(false)}>
                    <button className={`text-gray-900 hover:bg-gray-100 px-3 py-2 rounded-md text-sm font-medium flex items-center ${activePath.startsWith('/about') || activePath.startsWith('/partenaires') ? 'active-link' : ''}`}>
                      A Propos  <FontAwesomeIcon icon={faChevronDown} className="ml-1 h-3 w-3" />
                    </button>

                    <div
                      className={`absolute left-0 mt-2 w-screen max-w-6xl bg-white border border-gray-200 rounded-lg shadow-lg transition-all duration-300 z-50 transform -translate-x-1/4 ${about ? 'opacity-100 visible' : 'opacity-0 invisible'}`}>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 p-6">
                        
                        <div>
                          <h3 className={`text-lg font-semibold text-gray-900 mb-4 ${activePath.startsWith('/about') ? 'active-link' : ''}`}>Nous</h3>
                          <ul className="space-y-3">
                            <li><a onClick={handleAnchorClick} href='/about' className={`no-underline text-gray-600 hover:text-indigo-600 ${activePath === '/about' ? 'active-link' : ''}`}>Qui sommes nous ?</a></li>
                          </ul>
                        </div>
                        
                        {
                          partenaires.length != 0 && <div>
                            <h3 className={`text-lg font-semibold text-gray-900 mb-4 ${activePath.startsWith('/partenaires') ? 'active-link' : ''}`}>Partenaires</h3>
                            <ul className="space-y-3">
                              {partenaires.map((partenaire) => (
                                <li title={partenaire.name} key={partenaire.name}><a onClick={handleAnchorClick} className={`no-underline text-gray-600 hover:text-indigo-600 ${activePath.startsWith('/partenaires') ? 'active-link' : ''}`} style={{textDecoration: 'none'}} href={`/partenaires`} >{formatAuthor(partenaire.description, 17)}</a></li>
                              ))}
                            </ul>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  <a target="_blank" href="https://e-learning.youthfp.cm" className="no-underline text-gray-900 hover:bg-gray-100 px-3 py-2 rounded-md text-sm font-medium">E-Learning</a>
                </div>
              </div>
              <div className="flex-shrink-0 flex items-center">
                <a href="https://cameroon.unfpa.org/" className='no-underline' target="_blank" rel="noopener noreferrer">
                  <img src="/images/logo/unfpa.png" className="block h-8 w-auto" alt="UNFPA" />
                </a>
              </div>
            </div>
            <div className="sm:hidden absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0 justify-center w-full ">
              {/* Mobile menu button */}
              <div className="sm:hidden">
                <button onClick={() => setIsOpen(!isOpen)} type="button" className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500" aria-expanded={isOpen} id="mobile-menu-button">
                  <span className="sr-only">Open main menu</span>
                  <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- Mobile menu, show/hide based on menu state --> */}
        <div className={`sm:hidden ${isOpen ? 'block' : 'hidden'} bg-white`} id="mobile-menu">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <a href="/" onClick={handleAnchorClick} className={`no-underline bg-gray-100 text-gray-900 block px-3 py-2 rounded-md text-base font-medium ${activePath === '/' ? 'active-link' : ''}`}>Acceuil</a>

            {/* Mobile Products Dropdown */}
            <div className="relative">
              <button  onClick={() => setRessourcesM(!ressourcesM)} className={`w-full text-left text-gray-900 hover:bg-gray-100 px-3 py-2 rounded-md text-base font-medium flex items-center justify-between mobile-dropdown-trigger ${activePath.startsWith('/articles') || activePath.startsWith('/usraj') || activePath.startsWith('/service') || activePath.startsWith('/gallery') ? 'active-link' : ''}`}>
                <b><FontAwesomeIcon icon={faFolderOpen} className="ml-1 h-3 w-3" /> Ressources </b> <FontAwesomeIcon icon={faChevronDown} className="ml-1 h-3 w-3" />
              </button>
              <div className={`${ressourcesM ? 'block' : 'hidden'} px-4 py-2 mobile-dropdown-content"`}>
                {
                  articleSubMenu.length != 0 && <div className="border-l-2 border-indigo-500 pl-2 mb-4">
                    <h4 className={`font-medium text-gray-900 mb-2 ${activePath.startsWith('/articles') ? 'active-link' : ''}`}>Articles</h4>
                    <ul className="space-y-2">
                        {
                        articleSubMenu.map((menu) => (
                          <li title={menu.description} key={menu.name}><a onClick={handleAnchorClick} className={`no-underline text-gray-600 hover:text-indigo-600 block ${activePath === `/articles/${menu.id}` ? 'active-link' : ''}`} style={{textDecoration: 'none'}} href={`/articles/${menu.id}`} >{formatAuthor(menu.description, 30)}</a></li>
                        ))
                      }
                    </ul>
                  </div>
                }
                
                <div className="border-l-2 border-indigo-500 pl-2">
                  <h4 className={`font-medium text-gray-900 mb-2 ${activePath.startsWith('/usraj') || activePath.startsWith('/service') ? 'active-link' : ''}`}>USRAJ</h4>
                    <ul className="space-y-2">
                    <li title="Localisation des Unité de Santé de Reproduction des Ados Jeunes"><a onClick={handleAnchorClick} href="/usraj/location" className={`no-underline text-gray-600 hover:text-indigo-600 ${activePath.startsWith('/usraj') ? 'active-link' : ''}`}>Localisation des USRAJ</a></li>
                    <li title="Services des Unité de Santé de Reproduction des Ados Jeunes"><a onClick={handleAnchorClick} href="/service" className={`no-underline text-gray-600 hover:text-indigo-600 ${activePath.startsWith('/service') ? 'active-link' : ''}`}>Services</a></li>
                  </ul>
                </div>
                
                <div className="border-l-2 border-indigo-500 pl-2">
                  <h4 className={`font-medium text-gray-900 mb-2 ${activePath.startsWith('/gallery') ? 'active-link' : ''}`}>Mediatheque</h4>
                    <ul className="space-y-2">
                    <li title="Galerie d'images"><a onClick={handleAnchorClick} href="/gallery" className={`no-underline text-gray-600 hover:text-indigo-600 ${activePath.startsWith('/gallery') ? 'active-link' : ''}`}>Images</a></li>
                  </ul>
                </div>
              </div>
            </div>

            
            <div className="relative">
              <button  onClick={() => setAboutM(!aboutM)} className={`w-full text-left text-gray-900 hover:bg-gray-100 px-3 py-2 rounded-md text-base font-medium flex items-center justify-between mobile-dropdown-trigger ${activePath.startsWith('/about') || activePath.startsWith('/partenaires') ? 'active-link' : ''}`}>
                <b>A Propos </b> <FontAwesomeIcon icon={faChevronDown} className="ml-1 h-3 w-3" />
              </button>
              <div className={`${aboutM ? 'block' : 'hidden'} px-4 py-2 mobile-dropdown-content"`}>
                
                <div className="border-l-2 border-indigo-500 pl-2">
                  <h4 className={`font-medium text-gray-900 mb-2 ${activePath === '/about' ? 'active-link' : ''}`}>Nous</h4>
                  <ul className="space-y-2">
                    <li ><a onClick={handleAnchorClick} href="/about" className={`no-underline text-gray-600 hover:text-indigo-600 ${activePath === '/about' ? 'active-link' : ''}`}>Qui sommes nous ?</a></li>
                  </ul>
                </div>
                {
                  partenaires.length != 0 && <div className="border-l-2 border-indigo-500 pl-2 mb-4">
                    <h4 className={`font-medium text-gray-900 mb-2 ${activePath.startsWith('/partenaires') ? 'active-link' : ''}`}>Partenaires</h4>
                    <ul className="space-y-2">
                      {
                        partenaires.map((menu) => (
                          <li title={menu.name} key={menu.name}><a onClick={handleAnchorClick} className={`no-underline text-gray-600 hover:text-indigo-600 block ${activePath.startsWith('/partenaires') ? 'active-link' : ''}`} style={{textDecoration: 'none'}} href={`/partenaires`} >{formatAuthor(menu.name, 17)}</a></li>
                        ))
                      }
                    </ul>
                  </div>
                }
              </div>
            </div>
            <a target="_blank" href="https://e-learning.youthfp.cm" className="no-underline text-gray-900 hover:bg-gray-100 block px-3 py-2 rounded-md text-base font-medium">E-Learning</a>
          </div>
        </div>
      </nav>
    </header>
  );
}
